
const pageAuth = () => import(/* webpackChunkName: "authority-manage" */ './pageAuth');

export default [
    {
        path: '/pageMana/authority',
        name: 'pageAuth',
        component: pageAuth,
        meta: {
            access: {
                actionsCode: [],
                includeOrg: [],
                outsideOrg: [],
                includeOrgType: [],
                outsideOrgType: [],
            },
        },
    },
];
